export default __webpack_public_path__ + "static/media/logout.f0bd5fff.svg";